module.exports = __webpack_public_path__ + "static/media/left_girl_th.c3853388.png";